module.exports = __webpack_public_path__ + "static/media/bouteille2.1b29f177.svg";